<app-project-submenu></app-project-submenu>

<p
  class="text-muted mt-3 mb-3"
  i18n="@@project-keyvals-description"
>
  Der projektweite Datenspeicher ermöglicht es deinen Bots, Informationen zentral und dauerhaft abzulegen und
  untereinander auszutauschen – zum Beispiel Nutzerpräferenzen, Zähler oder Zwischenergebnisse. Befüllt wird er über
  den Logikeditor-Block RAGAI.PROJECTKEYVAL. Die gespeicherten Daten stehen allen Bots innerhalb dieses Projekts zur
  Verfügung und bleiben über einzelne Gespräche hinaus erhalten.
</p>

<p-confirmdialog></p-confirmdialog>
<p-menu
  #keyvalMenu
  [model]="this.activeKeyvalMenuItems"
  [popup]="true"
  appendTo="body"
></p-menu>

<ng-template #actionBtns>
  <p-button
    i18n-label="@@manage-delete-rules"
    label="Löschregeln verwalten"
    [badge]="'' + this.maxAgeRules.length"
    icon="ri-timer-line"
    severity="secondary"
    size="small"
    [outlined]="true"
    (onClick)="showRulesDialog = true"
  ></p-button>
</ng-template>

@if (this.keyvals.length > 0) {
<div class="d-flex justify-content-between align-items-center mb-2 mt-3">
  <div class="d-flex gap-2">
    <p-button
      i18n-label="@@delete-all-keyvals"
      label="Alle KeyVals löschen"
      severity="danger"
      size="small"
      (click)="this.confirmDeleteAll()"
    ></p-button>
    <ng-container [ngTemplateOutlet]="actionBtns"></ng-container>
    @if (this.systemEntryCount > 0) {
    <p-button
      [label]="this.systemEntriesToggleLabel"
      [badge]="'' + this.systemEntryCount"
      [icon]="this.showSystemEntries ? 'ri-eye-off-line' : 'ri-eye-line'"
      severity="secondary"
      size="small"
      [outlined]="true"
      i18n-pTooltip="@@system-entries-tooltip"
      pTooltip="Systemeinträge werden intern von RAGAI-Funktionen wie dem Gruppenchat angelegt."
      tooltipPosition="bottom"
      (onClick)="this.toggleSystemEntries()"
    ></p-button>
    }
    <p-button
      i18n-label="@@export-keyvals"
      label="Exportieren"
      icon="ri-download-line"
      severity="secondary"
      size="small"
      [outlined]="true"
      (onClick)="this.exportKeyvals()"
    ></p-button>
  </div>
  <p-iconfield>
    <p-inputicon class="ri ri-search-line" />
    <input
      pInputText
      type="text"
      [(ngModel)]="this.filterString"
      (ngModelChange)="this.filterKeyvals()"
      i18n-placeholder="@@search-placeholder"
      placeholder="Suchen..."
    />
  </p-iconfield>
</div>
}

<p-table
  [value]="this.filteredKeyVals"
  [rowHover]="this.keyvals.length > 0"
  styleClass="p-datatable-sm"
>
  <ng-template #header>
    @if (this.keyvals.length > 0) {
    <tr>
      <th>
        <span i18n="@@key">Schlüssel</span>
      </th>
      <th>
        <span i18n="@@value">Wert</span>
      </th>
      <th>
        <span i18n="@@grouped">Gruppierung</span>
      </th>
      <th>
        <span i18n="@@user-column">Betrifft</span>
      </th>
      <th style="width: 150px">
        <span i18n="@@actions">Aktionen</span>
      </th>
    </tr>
    }
  </ng-template>

  <ng-template
    #body
    let-keyval
  >
    <tr>
      <td>{{ keyval.key }}</td>
      <td>{{ keyval.value }}</td>
      <td>
        {{ keyval.type }}
        @if (this.isSystemEntry(keyval.type)) {
        <p-tag
          severity="secondary"
          value="Systemeintrag"
          i18n-value="@@keyval-system-tag"
          i18n-pTooltip="@@system-entries-tooltip"
          pTooltip="Systemeinträge werden intern von RAGAI-Funktionen wie dem Gruppenchat angelegt."
          tooltipPosition="top"
          class="ms-2"
        ></p-tag>
        }
      </td>
      <td>{{ getUserName(keyval.userId) }}</td>
      <td>
        <p-button
          [rounded]="true"
          severity="secondary"
          icon="ri ri-more-2-fill"
          styleClass="button-icon"
          (onClick)="openKeyvalMenu($event, keyval)"
        ></p-button>
      </td>
    </tr>
  </ng-template>

  <ng-template #emptymessage>
    <tr>
      <td
        colspan="5"
        class="text-center p-5 text-muted"
      >
        @if (this.keyvals.length === 0) {
        <ng-container i18n="@@project-keyvals-empty-state">
          Der KeyVal Store ist noch leer. Sobald ein Bot Schlüssel-Wert-Paare speichert, erscheinen sie hier.
        </ng-container>
        }
        @if (this.keyvals.length > 0) {
        <ng-container i18n="@@no-entries-filtered">
          Keine Einträge gefunden. Passe deine Suche an.
        </ng-container>
        }
        <br><br>
        <div class="text-center d-flex flex-column gap-2">
          <ng-container [ngTemplateOutlet]="actionBtns"></ng-container>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<!-- ===== Löschregeln Dialog ===== -->
<p-dialog
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [(visible)]="showRulesDialog"
  i18n-header="@@auto-delete-rules"
  header="Automatische Löschregeln"
  [style]="{ width: '900px' }"
>
  <p
    class="text-muted mb-3"
    i18n="@@maxage-description"
  >
    Definiere Regeln, um KeyVal-Einträge automatisch nach einer bestimmten Zeit zu löschen.
    Das Alter basiert auf der letzten Änderung oder dem letzten Lesen. Verwende * als Wildcard im Schlüsselmuster.
  </p>
  <div class="row mb-3">
    <div class="col-6">
      <span i18n="@@key-pattern">Schlüsselmuster</span>
      <input
        pInputText
        [(ngModel)]="newRuleKeyPattern"
        placeholder="z.B. temp_*"
        fluid
      >
    </div>
    <div class="col-6">
      <span i18n="@@delete-after">Löschen nach</span>
      <div class="d-flex gap-2">
        <input
          pInputText
          type="number"
          [(ngModel)]="newRuleMaxAgeSeconds"
          placeholder="60"
          style="flex: 1"
        >
        <p-select
          [(ngModel)]="newRuleTimeUnit"
          [options]="timeUnitOptions"
          optionLabel="label"
          optionValue="value"
          [style]="{'min-width': '130px'}"
          appendTo="body"
        ></p-select>
      </div>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col">
      <button
        pButton
        class="p-button-sm"
        (click)="addRule()"
        [disabled]="!newRuleKeyPattern || !newRuleMaxAgeSeconds"
        i18n="@@add-rule"
      >Regel hinzufügen</button>
    </div>
  </div>

  <p-table
    [value]="this.maxAgeRules"
    [rowHover]="true"
    class="p-datatable-sm"
  >
    <ng-template #header>
      <tr>
        <th i18n="@@key-pattern">Schlüsselmuster</th>
        <th i18n="@@delete-after">Löschen nach</th>
        <th
          style="width: 150px"
          i18n="@@actions"
        >Aktionen</th>
      </tr>
    </ng-template>

    <ng-template
      #body
      let-rule
    >
      <tr>
        <td>{{ rule.keyPattern }}</td>
        <td>{{ formatMaxAge(rule.maxAgeSeconds) }}</td>
        <td>
          <p-menu
            #ruleMenu
            [model]="this.getRuleMenuItems(rule)"
            [popup]="true"
            appendTo="body"
          ></p-menu>
          <p-button
            [rounded]="true"
            severity="secondary"
            icon="ri ri-more-2-fill"
            styleClass="button-icon"
            (onClick)="ruleMenu.toggle($event)"
          ></p-button>
        </td>
      </tr>
    </ng-template>

    <ng-template #emptymessage>
      <tr>
        <td
          colspan="3"
          class="text-center"
          i18n="@@no-maxage-rules"
        >Keine Löschregeln konfiguriert — Einträge bleiben bis zur manuellen Löschung bestehen.</td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>

<!-- ===== KeyVal bearbeiten Dialog ===== -->
<p-dialog
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [(visible)]="showEditKeyValDialog"
  i18n-header="@@edit-keyval-header"
  header="KeyVal bearbeiten"
  [style]="{ width: '500px' }"
>
  @if (editingEntry) {
  <div class="mb-3">
    <span
      class="d-block mb-1"
      i18n="@@key"
    >Schlüssel</span>
    <input
      pInputText
      [value]="editingEntry.key"
      [disabled]="true"
      fluid
    >
  </div>
  }
  <div class="mb-3">
    <span
      class="d-block mb-1"
      i18n="@@value"
    >Wert</span>
    <input
      pInputText
      [(ngModel)]="editValue"
      fluid
    >
  </div>
  <ng-template #footer>
    <p-button
      severity="secondary"
      i18n-label="@@cancel"
      label="Abbrechen"
      (onClick)="cancelEdit()"
    ></p-button>
    <p-button
      i18n-label="@@save"
      label="Speichern"
      (onClick)="saveEdit()"
    ></p-button>
  </ng-template>
</p-dialog>

<!-- ===== Regel bearbeiten Dialog ===== -->
<p-dialog
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [(visible)]="showEditRuleDialog"
  i18n-header="@@edit-rule-header"
  header="Regel bearbeiten"
  [style]="{ width: '500px' }"
>
  <div class="mb-3">
    <span
      class="d-block mb-1"
      i18n="@@key-pattern"
    >Schlüsselmuster</span>
    <input
      pInputText
      [(ngModel)]="editRuleKeyPattern"
      fluid
    >
  </div>
  <div class="mb-3">
    <span
      class="d-block mb-1"
      i18n="@@delete-after"
    >Löschen nach</span>
    <div class="d-flex gap-2">
      <input
        pInputText
        type="number"
        [(ngModel)]="editRuleMaxAgeSeconds"
        style="flex: 1"
      >
      <p-select
        [(ngModel)]="editRuleTimeUnit"
        [options]="timeUnitOptions"
        optionLabel="label"
        optionValue="value"
        [style]="{'min-width': '130px'}"
        appendTo="body"
      ></p-select>
    </div>
  </div>
  <ng-template #footer>
    <p-button
      severity="secondary"
      i18n-label="@@cancel"
      label="Abbrechen"
      (onClick)="cancelEditRule()"
    ></p-button>
    <p-button
      i18n-label="@@save"
      label="Speichern"
      (onClick)="saveEditRule()"
    ></p-button>
  </ng-template>
</p-dialog>